export default "__VITE_ASSET__DpAowy1p__"